import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import CircularProgress from "@mui/material/CircularProgress";
import DownloadFile from "../../../../components/downloadMediaFiles/downloadMediaFile";
import DownloadIcon from "@mui/icons-material/Download";
import CustomButton from "../../../../components/buttons/customButton";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function ViewFileModal({ show, handleClose, rowData }) {
  const [isLoading, setIsLoading] = useState(true);

  // Handle loading spinner when modal opens
  useEffect(() => {
    if (show) {
      setIsLoading(true);
      const timer = setTimeout(() => setIsLoading(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const renderPreview = () => {
    if (!rowData) return <Typography>No data</Typography>;

    const { file_name, file_type, file_url } = rowData;

    if (!file_type || !file_url) {
      return <Typography color="error">Invalid file data</Typography>;
    }

    // ✅ Image preview
    if (
      file_type === "image/jpeg" ||
      file_type === "image/png" ||
      file_type === "image/gif"
    ) {
      return (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="subtitle1" mb={2}>
            {file_name}
          </Typography>
          <img
            src={file_url}
            alt={file_name}
            style={{
              maxWidth: "100%",
              maxHeight: 400,
              borderRadius: 8,
            }}
          />
        </Box>
      );
    }

    // ✅ Video preview
    if (file_type === "video/mp4") {
      return (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="subtitle1" mb={2}>
            {file_name}
          </Typography>
          <video
            src={file_url}
            controls
            style={{
              maxWidth: "100%",
              maxHeight: 400,
              borderRadius: 8,
            }}
          />
        </Box>
      );
    }

    // ✅ PDF preview (embed or link)
    if (file_type === "application/pdf") {
      return (
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography variant="subtitle1" mb={2}>
            {file_name}
          </Typography>
          <embed
            src={file_url}
            type="application/pdf"
            width="100%"
            height="500px"
            style={{ border: "1px solid #ccc", borderRadius: 4 }}
          />
          <Typography variant="body2" mt={1}>
            <a href={file_url} target="_blank" rel="noopener noreferrer">
              Open PDF in new tab
            </a>
          </Typography>
        </Box>
      );
    }

    // ❌ Fallback for unsupported types
    return (
      <Typography color="warning.main">
        Cannot preview this file type: {file_type}
      </Typography>
    );
  };

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="sm"
      keepMounted
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: '#fdfdfd',
          boxShadow: 6,
          mt: 4,
          alignSelf: 'flex-start',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: 'var(--primary)',
          color: '#fff',
          px: 3,
          py: 1,
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        }}
      >
        <DialogTitle sx={{ m: 0, p: 0, fontSize: '1.2rem' }}>View File</DialogTitle>
        <IconButton onClick={() => handleClose()} sx={{ color: '#fff' }}>
          <CloseIcon />
        </IconButton>
      </Box>


      <DialogContent dividers>
        {isLoading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          renderPreview()
        )}
      </DialogContent>

      <DialogActions>
        <CustomButton status="download" label="Download"
          loadingLabel="Downloading..." icon={<DownloadIcon />} onClick={() =>
            DownloadFile(rowData.file_url, rowData.file_name)
          } />
      </DialogActions>
    </Dialog>
  );
}
